import { render, staticRenderFns } from "./emarticonAwardList.vue?vue&type=template&id=09cebc08&scoped=true"
import script from "./emarticonAwardList.vue?vue&type=script&lang=js"
export * from "./emarticonAwardList.vue?vue&type=script&lang=js"
import style0 from "./emarticonAwardList.vue?vue&type=style&index=0&id=09cebc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cebc08",
  null
  
)

export default component.exports